import request from '@/utils/request'

export function wxShare(data) {
    return request({
        url: '/api/wxchat/get_wx_share_config',
        method: 'get',
        params: data
    })
}
